module.exports = __webpack_public_path__ + "r-v3/img/group.6a64f13f.svg";